module.exports = __webpack_public_path__ + "assets/img/lime_skin.9deb1f8f.png";